import {
    APPLICATIONS_FAILURE,
    APPLICATIONS_REQUEST,
    APPLICATIONS_SUCCESS,
    APPLICATIONS_POST_SUCCESS,
    APPLICATION_PATCH_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
    /*
     * WHICH competition `data` holds, or null for every application.
     *
     * Applications are 2.0 MB unfiltered and `/competitions` reads ONE
     * competition's, so `isFetched` on its own would tell the next screen the
     * list is complete when it is a fifth of one percent of it. A consumer
     * that needs them all checks this first — same contract the
     * participants slice already uses.
     */
    fetchedCompetition: null,
};

export const applicationListReducer = (state = initialState, action) => {
    const {type, data, application} = action;
    switch (type) {
        case APPLICATIONS_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, application]
            }
        }

        case APPLICATION_PATCH_SUCCESS: {
            const newData = state.data.filter(d => d.id !== application.id)

            return {
                ...state,
                data: [...newData, application]
            }
        }

        case APPLICATIONS_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            fetchedCompetition: action.competition || null,
            data: preserveArrayReference(state.data, data),
        }}

        case APPLICATIONS_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case APPLICATIONS_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
